import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function Property() {
  return (
    <div>
        <Header/>
           {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover" style={{
        backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"
       
      }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Our Properties</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                          Our Properties
                        </li>
                    </ul>
                </div>
            </div>
        </div>
{/* 
        <!-- Project Section Start --> */}
        <section class="project-section fix section-padding">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="project-box-items">
                            <div class="project-thumb">
                                <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                <span class="project-post-box">
                                    PRICE $269
                                </span>
                            </div>
                            <div class="project-content">
                            <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                            <h3><a href="propertie-details.html">Houses with Private Parking</a></h3>
                            <ul class="project-list">
                                <li>
                                    <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                1860 sqft
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                    Bed 6
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/user.png" alt="img"/>
                                Bath 2
                                </li>
                            </ul>
                            <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="project-box-items">
                            <div class="project-thumb">
                                <img src="assets/img/home-1/project/project-02.jpg" alt="img"/>
                                <img src="assets/img/home-1/project/project-02.jpg" alt="img"/>
                                <span class="project-post-box">
                                    PRICE $269
                                </span>
                            </div>
                            <div class="project-content">
                            <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                            <h3><a href="propertie-details.html">Furnished Homes</a></h3>
                            <ul class="project-list">
                                <li>
                                    <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                1860 sqft
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                    Bed 6
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/user.png" alt="img"/>
                                Bath 2
                                </li>
                            </ul>
                            <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="project-box-items">
                            <div class="project-thumb">
                                <img src="assets/img/home-1/project/project-03.jpg" alt="img"/>
                                <img src="assets/img/home-1/project/project-03.jpg" alt="img"/>
                                <span class="project-post-box">
                                    PRICE $269
                                </span>
                            </div>
                            <div class="project-content">
                            <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                            <h3><a href="propertie-details.html">Single-Family Homes</a></h3>
                            <ul class="project-list">
                                <li>
                                    <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                1860 sqft
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                    Bed 6
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/user.png" alt="img"/>
                                Bath 2
                                </li>
                            </ul>
                            <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="project-box-items">
                            <div class="project-thumb">
                                <img src="assets/img/home-1/project/project-04.jpg" alt="img"/>
                                <img src="assets/img/home-1/project/project-04.jpg" alt="img"/>
                                <span class="project-post-box">
                                    PRICE $269
                                </span>
                            </div>
                            <div class="project-content">
                            <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                            <h3><a href="propertie-details.html">City Center Homes</a></h3>
                            <ul class="project-list">
                                <li>
                                    <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                1860 sqft
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                    Bed 6
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/user.png" alt="img"/>
                                Bath 2
                                </li>
                            </ul>
                            <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="project-box-items">
                            <div class="project-thumb">
                                <img src="assets/img/home-1/project/project-05.jpg" alt="img"/>
                                <img src="assets/img/home-1/project/project-05.jpg" alt="img"/>
                                <span class="project-post-box">
                                    PRICE $269
                                </span>
                            </div>
                            <div class="project-content">
                            <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                            <h3><a href="propertie-details.html">Mid-Range Houses</a></h3>
                            <ul class="project-list">
                                <li>
                                    <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                1860 sqft
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                    Bed 6
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/user.png" alt="img"/>
                                Bath 2
                                </li>
                            </ul>
                            <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="project-box-items">
                            <div class="project-thumb">
                                <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                <span class="project-post-box">
                                    PRICE $269
                                </span>
                            </div>
                            <div class="project-content">
                            <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                            <h3><a href="propertie-details.html">Houses with Private Parking</a></h3>
                            <ul class="project-list">
                                <li>
                                    <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                1860 sqft
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                    Bed 6
                                </li>
                                <li>
                                    <img src="assets/img/home-1/project/user.png" alt="img"/>
                                Bath 2
                                </li>
                            </ul>
                            <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-nav-wrap text-center">
                    <ul>
                        <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-left"></i></a></li>
                        <li class="active"><a class="page-numbers" href="#">01</a></li>
                        <li><a class="page-numbers" href="#">02</a></li>
                        <li><a class="page-numbers" href="#">03</a></li>
                        <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-right"></i></a></li>
                    </ul>
                </div>
            </div>
        </section>
         <Footer />
    </div>
  )
}

export default Property